<template>
  <Forms ref="frmMenu"
        :title="title"
        :showClearButton="false"
        :showBackButton="isUndeleting || showSettings"
        :showTipFooter="false"
        :showSettings="hasRole(roles.RW_OPER_DOC_SETTINGS) && !(showSettings || isUndeleting || addingFolder || startupFolderId || selectFolder || isSearching)"
        :showReload="!(showSettings || isUndeleting || addingFolder || isSearching)"
        v-on:Reload="onLoad"
        v-on:Settings="onSettings"
        v-on:Back="onBack"
        v-on:Search="onSearch" >
        <!-- :showSearchButton="!isSearching && !startupFolderId && !selectFolder" -->
    <ul class="pl-1 pt-1" v-show="showSettings">
      <li class="pt-1 pb-1"><strong><i class="fas fa-archive pr-2"></i>{{$lang.Documents.Menu.Settings.Title}}</strong>
        <ul class="pl-1 pt-1">
          <li class="pt-1 pb-1 pl-3">
            <b-link href="#" @click="$emit('editSubject')">
              <i class="text-third fas fa-flag pr-2"></i>{{$lang.Documents.Menu.Settings.Subjects}}
            </b-link>
          </li>
          <li class="pt-1 pb-1 pl-3">
            <b-link href="#" @click="$emit('editType')">
              <i class="text-third fas fa-shapes pr-2"></i>{{$lang.Documents.Menu.Settings.Types}}
            </b-link>
          </li>
          <li class="pt-1 pb-1 pl-3">
            <b-link href="#" @click="$emit('editTag')">
              <i class= "text-third fas fa-bookmark pr-2"></i>{{$lang.Documents.Menu.Settings.Tags}}
            </b-link>
          </li>
        </ul>
      </li>
    </ul>

    <!-- <Search v-show="isSearching" v-model="searchForm" /> -->
    <template #header v-if="!isUndeleting && !startupFolderId">
      <div class="align-items-center" style="display: inline-flex">
        <input type="text" class="ml-3" style="width: 300px; padding-bottom: 0; border-color: lightgray; outline: none;" :placeholder="$lang.Common.PlaceholderSearch" v-model="searchForm.nome.value" :disabled="isSearching" v-if="!showFavor">
        <span v-if="showFavor">
          <i class="fas fa-star text-warning mr-1"></i>{{$lang.Documents.Menu.MyFavorites}}
        </span>
        <i v-if="!isSearching" @click="onSearch(true)" class="fa fa-search ml-3 pointer"></i>
        <i v-if="isSearching" @click="onBackSearch" class="fas fa-angle-double-left ml-3 pointer"></i>
      </div>
    </template>

    <b-overlay :show="waiting" :opacity="0.95" blur="5px" variant="transparent" v-show="!(showSettings)">
      <template #overlay>
        <div class="text-center">
          <i class="far fa-edit fa-3x"></i>
        </div>
      </template>
      <div class="form-group row">
        <div class="col-md-12">
          <div>
            <div v-show="!isUndeleting && !startupFolderId && !isSearching" class="pt-1 pb-1">
              <b-link ref="showFavorComp" href="#" tabindex="-1" @click="onSearchFavor">
                <i class="fas fa-star text-warning mr-1"></i>{{$lang.Documents.Menu.MyFavorites}}
              </b-link>
            </div>
            <file-tree-view
              ref="treeview"
              rootName="Zopone"
              v-model="folders"
              :serializer="it => it.nome"
              childrenField="gedPastas"
              fatherId="gedPastaPaiID"
              :startOpen="false"
              :showAddButton="it => !isSearching && hasFolderPermission(folderPermission.WRITE, it)"
              :showEditButton="it => !isSearching && hasFolderPermission(folderPermission.WRITE, it)"
              :showDeleteButton="it => !isSearching && hasFolderPermission(folderPermission.DELETE, it)"
              :showDownloadButton="it => !isUndeleting && !isSearching && !startupFolderId && hasFolderPermission(folderPermission.DOWNLOAD, it)"
              :showUndeleteButton="!selectFolder && !startupFolderId && !startupFolderId"
              :showCopyStructureButton="!isUndeleting && !isSearching && !startupFolderId"
              :showRoot="!isUndeleting && !isSearching"
              :isUndeleting="isUndeleting"
              :isSearching="isSearching"
              :iconBeforeName="it => getIconBeforeName(it)"
              :isStructCopySet="isStructCopySet"
              :canDrag="!isSearching && !startupFolderId && hasRole(roles.RW_OPER_DOC_SETTINGS)"
              v-on:add="onAdd"
              v-on:edit="onEdit"
              v-on:open="onOpen"
              v-on:close="onClose"
              v-on:selectitem="onSelectItem"
              v-on:delete="onDelete"
              v-on:undelete="onUndeleteItem"
              v-on:endMove="onEndMove"
              v-on:structCopy="onStructCopy"
              v-on:structCopyExecute="onStructCopyExecute">
              <template v-if="isUndeleting" slot-scope="{item}">
                <FoldersName v-if="item.foldersName" :names="item.foldersName" />
                <span v-else>{{$lang.Common.Loading}}</span>
                <span class="ml-3 text-muted">{{$lang.Documents.Menu.RemovedIn}} {{ item.dataAcaoFormatada }}</span>
              </template>
              <template v-if="isSearching" slot-scope="{item}">
                <div class="d-flex flex-column">
                  <small class="w-100" style="overflow-wrap: break-word; white-space: normal;">{{ ' / ' + (item.nomePastas ? (item.nomePastas.join(' / ') + ' / ') : '') }}</small>
                  <strong>{{ item.nome }}</strong>
                </div>
              </template>
              <template #afterName="{item}" v-if="!isUndeleting">
                <i class="fas fa-star text-warning pointer" v-if="item.favorito" @click="onFavoriteFolder(item, false)"></i>
                <i class="far fa-star text-warning pointer" v-else @click="onFavoriteFolder(item, true)"></i>
              </template>
            </file-tree-view>
            <b-button v-if="isSearching && searchingPage < searchingTotalPages" class="w-100 m-3" @click="onSearch(false)">{{ $lang.Documents.ButtonLoadSearchingPage }}...</b-button>
          </div>
        </div>
      </div>
    </b-overlay>

    <template v-slot:action>
      <b-link href="#"
              v-show="!(isUndeleting || showSettings || addingFolder || isSearching || startupFolderId || selectFolder)"
              v-b-tooltip.hover :title="$lang.Documents.Menu.Tooltip.ButtonUndelete"
              v-on:click="onUndelete">
        <i class="fas fa-recycle text-third"></i>
      </b-link>
      <!-- <b-link href="#"
              v-show="!(isUndeleting || showSettings || addingFolder || isSearching || startupFolderId || selectFolder)"
              v-b-tooltip.hover :title="$lang.Documents.Menu.Tooltip.ButtonSearch"
              v-on:click="onClickSearch">
        <i class="fas fa-search text-third"></i>
      </b-link> -->
    </template>
  </Forms>
</template>

<script>
import DocMenu from './docmenu.js'
export default DocMenu
</script>

<style scoped>
li {
  list-style: none;
}

li.selected {
  box-shadow: 0px 0.5px 1px 0px grey;
  background-color: #e6e9ea94;
  font-weight: bold;
  padding: 5px;
}

div >>> .card-block {
  max-height: 70vh;
  overflow-x: auto;
}

* >>> .treeview-item {
  font-size: 12px;
}

* >>> .card {
  margin-bottom: 0;
}

.far.fa-star {
  display: none;
}

* >>> .treeview-item:hover .far.fa-star {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/menu/docmenu.vue